import { Dispatch, SetStateAction } from 'react';

export type ID = undefined | null | number | string;

export type uuid = undefined | null | string;

export type PaginationState = {
  page: number;
  items_per_page: 10 | 20 | 25 | 30 | 50 | 100 | 250 | 500;
  links?: Array<{ label: string; active: boolean; url: string | null; page: number | null }>;
  pages: number;
};

export type SortState = {
  sort?: string;
  order?: 'asc' | 'desc';
};

export type FilterState = {
  filter?: unknown;
  role?: string; // WST-319: Clinic Staff `?role=` (sent as is, not as filter_role)
};

export type SearchState = {
  search?: string;
};

export type AddConnectionState = {
  hideTable?: boolean;
};

export type Response<T> = {
  data?: T;
  payload?: {
    message?: string;
    errors?: {
      [key: string]: Array<string>;
    };
    pagination?: PaginationState;
  };
};

export type QueryState = PaginationState & SortState & FilterState & SearchState & AddConnectionState;

export type QueryRequestContextProps = {
  state: QueryState;
  updateState: (updates: Partial<QueryState>) => void;
};

export const initialQueryState: QueryState = {
  page: 1,
  pages: 1,
  items_per_page: 20,
};

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
};

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined;
  refetch: () => void;
  isLoading: boolean;
  query: string;
};

export const initialQueryResponse = { refetch: () => {}, isLoading: false, query: '' };

export type ListViewContextProps = {
  selected: Array<ID>;
  setSelected: (selectedIds: Array<ID>) => void;
  onSelect: (selectedId: ID) => void;
  onSelectAll: () => void;
  clearSelected: () => void;
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID;
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>;
  isAllSelected: boolean;
  disabled: boolean;
  rowCount: number | undefined;
  setRowCount: (rowCount: number) => void;
};

export const initialListView: ListViewContextProps = {
  selected: [],
  setSelected: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  isAllSelected: false,
  disabled: false,
  rowCount: undefined,
  setRowCount: () => {},
};
